'use client';
import { ToastContext } from '@/pagesComponents/Layout';
import { sendAchatForm } from '@/services/achats';
import Errors from '@/services/errors';
import { forwardRef, useContext, useEffect, useImperativeHandle, useState } from 'react';
import Button from '@/components/Button';

const AchatForm = ({ model, tirageId, submitFormflow, literals }, ref) => {
  const updateToast = useContext(ToastContext);

  const [numberOfFeuillet, setNumberOfFeuillet] = useState(null);
  const [numberOFMoitieMoitie, setNumberOFMoitieMoitie] = useState(null);
  const [totalFeuillet, setTotalFeuillet] = useState(0);
  const [totalMoitieMoitie, setTotalMoitieMoitie] = useState(0);
  const [montantTotal, setMontantTotal] = useState(totalFeuillet + totalMoitieMoitie);
  const [formIsValid, setFormIsValid] = useState(false);
  const [disableForm, setDisableForm] = useState(false);

  useImperativeHandle(ref, () => ({
    triggerHandleBonDeCommandeSubmit: (e) => {
      handleBonDeCommandeSubmit(e);
    },
  }));

  const handleChangeQteFeuillet = (e) => {
    setNumberOfFeuillet(e.target.value);
    // scroll to the bottom of the page
    window.scrollTo(0, document.body.scrollHeight);
  };

  const handleBonDeCommandeSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const dataToSend = Object.fromEntries(formData.entries());

      dataToSend.MontantMoitieMoitie = totalMoitieMoitie;
      dataToSend.MontantFeuillet = totalFeuillet;
      dataToSend.TotalAchat = montantTotal;
      const data = await sendAchatForm(dataToSend, tirageId);
      // dissable achat form  and send result to parent
      setDisableForm(true);
      submitFormflow(data);
    } catch (e) {
      Errors.handleError(e, updateToast);
    }
  };

  useEffect(() => {
    setMontantTotal(totalFeuillet + totalMoitieMoitie);
  }, [totalFeuillet, totalMoitieMoitie]);

  useEffect(() => {
    if (numberOfFeuillet > 0) {
      setFormIsValid(true);
    } else {
      setFormIsValid(false);
      setNumberOFMoitieMoitie(null);
      const numberOfMoitieMoitieInput = document.getElementById('QteMoitieMoitie');
      numberOfMoitieMoitieInput.value = '';
    }
    setTotalMoitieMoitie(numberOFMoitieMoitie * (model?.prixMoitieMoite ?? 0) || 0);

    setTotalFeuillet(numberOfFeuillet * (model?.prixFeuillet ?? 0)) || 0;
  }, [numberOFMoitieMoitie, numberOfFeuillet]);

  useEffect(() => {
    if (model?.demandeAchat?.statut === 4) {
      // fill form from demandeAchat and
      const form = document.getElementById(literals.achatForm);
      const feuilletInput = form.querySelector('input[name="QteFeuillet"]');
      const moitieMoitieInput = form.querySelector('input[name="QteMoitieMoitie"]');
      feuilletInput.value = model.demandeAchat.qteFeuillet;
      moitieMoitieInput.value = model.demandeAchat.qteMoitieMoitie;
      setNumberOFMoitieMoitie(model.demandeAchat.qteMoitieMoitie);
      setNumberOfFeuillet(model.demandeAchat.qteFeuillet);
    }
  }, [model]);

  return (
    <form id={literals.achatForm} className={'w-md-75'} onSubmit={(e) => handleBonDeCommandeSubmit(e)}>
      {/*hidden inputs*/}
      <input type="hidden" name={'WhoLikesHoney'} placeholder={'me'} />
      <input type="hidden" name={'TirageId'} value={tirageId} />
      <div className="my-3 ">
        <div className="row form-group">
          <div className="col-8">
            <label htmlFor="QuantiteFeuillet" className="form-label text-center">
              Pad 5 Feuilles de 9 faces
            </label>
          </div>
          <div className="col-4">
            <div className="total">Prix Total</div>
          </div>
        </div>
        <div className="row">
          <div className="col-8">
            <input
              id="QuantiteFeuillet"
              name={'QteFeuillet'}
              type={'number'}
              className="form-control"
              placeholder={`prix unitaire : ${Number(model?.prixFeuillet ?? 0).toFixed(2)} $`}
              // value={numberOfFeuillet}
              onChange={(e) => handleChangeQteFeuillet(e)}
              disabled={disableForm}
            />
          </div>
          <div className="col-4 d-flex align-items-center">
            <div className="value">{Number(totalFeuillet).toFixed(2)} $</div>
          </div>
        </div>
      </div>

      <div className="row form-group">
        <div className="col-8">
          <label htmlFor="QteMoitieMoitie" className="form-label text-center">
            Feuillet Moitié - Moitié 1 page - 2 cartes
          </label>
        </div>
        <div className="col-4">
          <div className="total"></div>
        </div>
      </div>
      <div className="row">
        <div className="col-8">
          <input
            id="QteMoitieMoitie"
            name={'QteMoitieMoitie'}
            type={'number'}
            className="form-control"
            placeholder={`prix unitaire : ${Number(model?.prixMoitieMoite ?? 0).toFixed(2)} $`}
            disabled={!formIsValid || disableForm}
            onChange={(e) => setNumberOFMoitieMoitie(e.target.value)}
          />
          {!formIsValid && (
            <small className="text-danger">Le nombre de feuillet doit être supérieur à 0</small>
          )}
        </div>
        <div className="col-4 d-flex align-items-center">
          <div className="value">{Number(totalMoitieMoitie).toFixed(2)} $</div>
        </div>
      </div>
      {formIsValid && (
        <>
          <div className="row my-1">
            <div className="col-8 d-flex justify-content-end">Total :</div>
            <div className="col-4">{Number(montantTotal).toFixed(2)} $</div>
          </div>
          {!disableForm && (
            <div className="my-3 row justify-content-center justify-content-md-end">
              <div className="col-6 col-xl-5">
                <Button type={'submit'} className={' btn btn-sales'}>
                  Payer Maintenant
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </form>
  );
};
export default forwardRef(AchatForm);
